import DataTable from 'react-data-table-component'
import tableCustomStyles from './TableCustomeStyle'
import SortIcon from '../../../assets/svg/SortIcon'
import CustomPagination from '../CustomPagination/CustomPagination'
import './style.css'
import RotatingLinesLoader from '../Loaders/RotatingLinesLoader'

function ReactDataTable({
    styleProps,
    data,
    columns,
    handleSelectedRowsChange,
    removePagination,
    pageCount,
    activePage,
    rowPerPages,
    totaldata,
    handleRowsPerPage,
    handleColumnSort,
    handlePageClick,
    isSelectableRows,
    isLoading,
    isSelectSingleRow,
    handleOnRowClicked,
    handleOnRowDoubleClicked,
    conditionalRowStyles,
    boderSelection = false,
    gridBorders = false,
    noDataMessage = 'There are no records to display',
    selectableRowsNoSelectAll = false, // Add this new prop
    hideSortIcon = false,
    clearSelectedRows = false,
    sortServer = true, // Add sortServer prop with default true
    selectableRowSelected, // Add this prop for visual selection
    dense = false, // Add dense prop for compact rows (better performance)
     paginationVariant,
     className,
}) {
    
    const modifiedColumns = selectableRowsNoSelectAll 
        ? columns.map(col => {
            if (col.selector === 'selection') {
                return {
                    ...col,
                    header: () => null // Hide the header checkbox
                }
            }
            return col
        })
        : columns

    // Custom handle selection change
    const handleSelectionChange = ({ selectedRows }) => {
        if (isSelectSingleRow && selectedRows.length > 1) {
           
            const lastSelected = selectedRows[selectedRows.length - 1]
            handleSelectedRowsChange?.({ selectedRows: [lastSelected] })
        } else {
            handleSelectedRowsChange?.({ selectedRows })
        }
    }

    return (
        <>
            <DataTable
                customStyles={tableCustomStyles(
                    isSelectableRows,
                    boderSelection,
                    gridBorders
                )}
                conditionalRowStyles={conditionalRowStyles}
                className={`table-custom-border ${className || ''}`}
                columns={modifiedColumns}
                data={data}
                sortServer={sortServer}
                onSort={handleColumnSort}
                progressPending={isLoading}
                persistTableHead
                selectableRows={isSelectableRows}
                selectableRowsSingle={isSelectSingleRow || false}
                onSelectedRowsChange={handleSelectionChange}
                pagination={removePagination ? false : true}
                clearSelectedRows={clearSelectedRows}
                selectableRowsHighlight
                highlightOnHover
                paginationServer
                dense={dense}
                progressComponent={<RotatingLinesLoader />}
                paginationComponent={() => {
                    return (
                        <CustomPagination
                            styleProps={styleProps}
                            handleRowsPerPage={handleRowsPerPage}
                            handlePageClick={handlePageClick}
                            totalData={totaldata}
                            pageCount={pageCount}
                            activePage={activePage}
                            rowPerPages={rowPerPages}
                             paginationVariant={paginationVariant}
                        />
                    )
                }}
                sortIcon={!hideSortIcon ? <SortIcon /> : <></> } 
                onRowClicked={handleOnRowClicked}
                onRowDoubleClicked={handleOnRowDoubleClicked}
                noDataComponent={<p className="text-center py-4">{noDataMessage}</p>}
                selectableRowsNoSelectAll={selectableRowsNoSelectAll} // Pass to DataTable
                selectableRowSelected={selectableRowSelected} // Pass to DataTable for visual selection
            />
        </>
    )
}

export default ReactDataTable